import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'dropdown-tipo-endereco',
  templateUrl: './dropdown-tipo-endereco.component.html',
  styleUrls: ['./dropdown-tipo-endereco.component.scss']
})
export class DropdownTipoEnderecoComponent implements OnInit {

  selected = '';

  @Input() formGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
